export const LOGOS = {
  EmmLogoUrl: 'https://bccdn.britishcouncil.org/logos/apps/EMM.svg',
};
